import { render, staticRenderFns } from "./more-info.vue?vue&type=template&id=e5054486&scoped=true"
import script from "./more-info.vue?vue&type=script&lang=js"
export * from "./more-info.vue?vue&type=script&lang=js"
import style0 from "./more-info.vue?vue&type=style&index=0&id=e5054486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5054486",
  null
  
)

export default component.exports